(function () {
  const BRAND_CONFIG = {
    "lizush": {
      name:"LIZUSH",
      sub:"NATURAL BATH & BODY CARE",
      logo:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/lizush-logo.png?v=1791191767",
      lead:"Autocuidado natural presentado como regalo: fórmulas limpias, aroma botánico y cajas pensadas para sorprender.",
      paragraphs:[
        "Lizush nació de la pasión de su fundadora, Lizzy Siman-Tov, por una cosmética natural y no tóxica. La marca elabora productos de baño y cuerpo a partir de ingredientes naturales, aceites esenciales y extractos botánicos.",
        "Su propuesta se apoya especialmente en los sets de regalo: combinaciones de baño, cuerpo, aromaterapia y cuidado personal preparadas para distintas ocasiones, desde un detalle de agradecimiento hasta regalos de boda o bienvenida de bebé.",
        "La marca declara fórmulas 100% naturales y cruelty-free, sin sulfatos, fragancias ni colorantes artificiales, parabenos, ftalatos, petroquímicos, propilenglicol ni PEGs."
      ],
      badges:["🌿 100% natural","🐰 Cruelty-free","🎁 Especialista en regalo","🧴 Bath & Body"],
      cards:[
        {eyebrow:"Regalo bienestar",title:"Karité + exfoliante de pomelo",text:"Dúo corporal para exfoliar y nutrir, presentado como un regalo de autocuidado.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/set-scrub-shea-5d96d9cc.jpg?v=1791130271",href:"/products/shea-butter-and-body-scrub-reviving-set-grapefruit",cta:"Ver set →"},
        {eyebrow:"Regalo especial",title:"Bienvenida bebé",text:"Set orgánico de cuidado para celebrar una llegada con una selección preparada para regalar.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/copy-of-self-care-gift-box-natural-skincare-gift-set-cd98480e.jpg?v=1791130272",href:"/products/small-organic-new-baby-gift-set-welcome-little-one",cta:"Ver regalo →"}
      ]
    },
    "magrada-organic-cosmetics": {
      name: "MAGRADA",
      sub: "ORGANIC COSMETICS",
      lead: "Belleza nórdica, fórmulas botánicas y rituales completos para cuerpo y cabello.",
      paragraphs: [
        "Magrada es una firma estonia nacida en 2015 e inspirada por la naturaleza de Hiiumaa. Su propuesta mezcla ingredientes de origen vegetal, cuidado consciente y una imagen de marca especialmente cuidada.",
        "En Casa a Cuestas damos prioridad a sets, rutinas y formatos de descubrimiento que permiten probar varios pasos de una misma línea sin comprar cada producto por separado.",
        "Entre sus productos más reconocibles está la línea capilar de ruibarbo, cuya mascarilla obtuvo un Pure Beauty Global Award en 2021. También destacan sus gamas de lavanda, algas y flor de tilo."
      ],
      badges: ["🌿 Inspiración nórdica","🐰 Cruelty-free","♻️ Enfoque sostenible","🏆 Marca premiada"],
      cards: [
        {eyebrow:"Ritual destacado",title:"Noche Nórdica",text:"Lavanda, pomelo y enebro en un ritual corporal y de hogar pensado para regalar o desconectar.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/magrada-ritual-noche-nordica-promo.png?v=1791186574",href:"/products/ritual-noche-nordica-magrada-3-piezas",cta:"Descubrir ritual →"},
        {eyebrow:"Pack Oportunidad",title:"Ritual Viaje Capilar · 3 piezas",text:"Formato descubrimiento para limpiar, suavizar y nutrir el cabello allá donde vayas.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/magrada-ritual-viaje-capilar-promo.png?v=1791186564",href:"/products/ritual-viaje-capilar-magrada-3-piezas",cta:"Ver pack →"}
      ]
    },
    "candledust": {
      name:"CANDLEDUST",
      sub:"POWDER CANDLES · HOME FRAGRANCE",
      lead:"Velas que empiezan siendo polvo y terminan siendo parte de la decoración.",
      paragraphs:[
        "Candledust nació en Estonia con una idea distinta: convertir la vela en un objeto flexible, recargable y visual. La cera en polvo permite renovar la mecha, reutilizar recipientes y cambiar el aspecto de la vela con facilidad.",
        "En Casa a Cuestas la trabajamos en sets de 3 y 4 piezas para que la experiencia tenga sentido como regalo, ritual de hogar o primera toma de contacto con la marca.",
        "La propuesta de Candledust destaca tanto por su estética como por una forma de uso diferente: rellenar, renovar la mecha y reutilizar el recipiente permite adaptar la vela a cada espacio y momento."
      ],
      badges:["🕯️ Vela en polvo","♻️ Reutilizable","🎁 Regalo","🎥 Cómo funciona"],
      cards:[
        {eyebrow:"Pack Oportunidad",title:"Rhubarb Sparkle · 3 piezas",text:"Una forma fácil de probar la vela en polvo con una de las fragancias más visuales de la marca.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/candledust-powder-rhubarb-set-completo-1080-square.png?v=1791130581",href:"/products/set-vela-en-polvo-rhubarb-sparkle-3-piezas",cta:"Ver set →"},
        {eyebrow:"Versión premium",title:"Rhubarb Sparkle · 4 piezas",text:"Set ampliado con presentación más completa para regalo o para empezar con todo lo necesario.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/candledust-rhubarb-sparkle-premium-4-pack-completo.png?v=1791151562",href:"/products/set-premium-vela-en-polvo-rhubarb-sparkle-4-piezas",cta:"Ver premium →"}
      ]
    },
    "candledust-1": { alias:"candledust" },
    "ewart-woods": {
      name:"EWART WOODS",
      sub:"WOOD DESIGN · LATVIA",
      logo:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/ewart-woods-logo.png?v=1791191796",
      lead:"Madera funcional, líneas limpias y piezas pensadas para formar parte de la casa.",
      paragraphs:[
        "Ewart Woods convierte contrachapado de abedul y chapas de madera natural en estanterías, soportes y pequeños muebles con mucha personalidad.",
        "El proceso mezcla mecanizado preciso con acabado manual. En Casa a Cuestas nos interesa especialmente porque resuelve necesidades reales sin caer en el mueble infantil o auxiliar de aspecto genérico.",
        "Sus piezas están pensadas para integrarse en espacios reales: estanterías, taburetes y pequeños muebles con una presencia visual cálida y funcional."
      ],
      badges:["🌳 Madera","🛠️ Acabado manual","🇱🇻 Diseño letón","🏠 Hogar"],
      cards:[
        {eyebrow:"Diseño funcional",title:"Estanterías que también decoran",text:"Piezas ligeras visualmente, con formas orgánicas y mucha presencia en pared.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/collections/floating-shelf-curveline-3d63bed1_6e1db2d7-35aa-4003-b67b-bc3a83ab72eb.jpg?v=1791061848",href:"/products/floating-shelf-curveline",cta:"Ver colección →"},
        {eyebrow:"Niños + hogar",title:"Muebles que no parecen de juguetería",text:"Estanterías, taburetes y piezas infantiles pensadas para integrarse de verdad en casa.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/kids-wooden-bookshelves-capsule-large-b7960682.jpg?v=1791060933",href:"/products/kids-wooden-bookshelves-capsule-large",cta:"Descubrir Ewart →"}
      ]
    },
    "hoia-homespa": {
      name:"HOIA",
      sub:"HOMESPA",
      logo:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/hoia-logo.png?v=1791187600",
      lead:"Spa en casa con aceites, extractos botánicos y fórmulas de cuidado intensivo.",
      paragraphs:[
        "HOIA homespa nace en Estonia con una filosofía muy directa: convertir rutinas cotidianas de rostro, cuerpo y cabello en pequeños rituales de spa.",
        "La marca apuesta por fórmulas sensoriales y rutinas de cuidado que convierten gestos cotidianos en momentos de bienestar en casa.",
        "En Casa a Cuestas la agrupamos por necesidades y rituales para que sea fácil entender qué combina con qué."
      ],
      badges:["🌿 Botánicos","🧖 Homespa","💧 Cuidado intensivo","⭐ Reviews"],
      cards:[
        {eyebrow:"Ritual facial",title:"Hidratación Facial · 3 piezas",text:"Tónico, aloe con pepino y aceite de hibisco para una rutina diaria equilibrada.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/sugavniisutav-naotoonik-1.png?v=1791129588",href:"/products/ritual-hoia-hidratacion-facial-3-piezas",cta:"Ver ritual →"},
        {eyebrow:"Ritual corporal",title:"Reafirmante Corporal · 3 piezas",text:"Exfoliante, tratamiento reafirmante y aceite corporal en una rutina completa.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/firming-cellulite-cream-supermodel-20-100ml-5b6ce2f6.jpg?v=1791129581",href:"/products/ritual-hoia-reafirmante-corporal-3-piezas",cta:"Ver ritual →"}
      ],
      featuredProducts:[
        {title:"Ritual HOIA Hidratación Facial · 3 piezas",price:"119,90 €",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/sugavniisutav-naotoonik-1.png?v=1791129588",href:"/products/ritual-hoia-hidratacion-facial-3-piezas"},
        {title:"Ritual HOIA Reafirmante Corporal · 3 piezas",price:"134,90 €",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/DSC_0858-scaled-1.jpg?v=1791129587",href:"/products/ritual-hoia-reafirmante-corporal-3-piezas"},
        {title:"Ritual HOIA Cabello Nórdico · 3 piezas",price:"109,90 €",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/W2A1911v.jpg?v=1791129603",href:"/products/ritual-hoia-cabello-nordico-3-piezas"},
        {title:"Ritual HOIA Glow & Renovación · 3 piezas",price:"109,90 €",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/YTD-w2Ov.jpg?v=1791129591",href:"/products/ritual-hoia-glow-renovacion-3-piezas"}
      ]
    },
    "leg-go": {
      name:"leg&go",
      sub:"GROWING WITH KIDS",
      logo:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/leg-go-logo.jpg?v=1791187605",
      lead:"Movimiento, juego y autonomía infantil con productos pensados para crecer con los niños.",
      paragraphs:[
        "leg&go diseña bicicletas evolutivas, estructuras Pikler, torres de aprendizaje y accesorios con una idea común: alargar la vida útil de cada producto.",
        "En Casa a Cuestas nos interesa precisamente por esa lógica evolutiva: menos objetos de usar una temporada y más piezas que acompañan distintas etapas.",
        "Sus productos destacan por adaptarse a distintas etapas del crecimiento, favoreciendo el movimiento, el equilibrio y la autonomía durante más tiempo."
      ],
      badges:["🚲 Evolutivo","🧗 Movimiento","🪵 Madera","👶 Crece con ellos"],
      cards:[
        {eyebrow:"Producto evolutivo",title:"Balance Bike + pedales + downhill",text:"Un solo concepto que acompaña distintas fases de aprendizaje.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/leggo-balance-bike-3in1-8beed271.jpg?v=1791133599",href:"/products/set-evolucion-leg-go-balance-bike-pedales-downhill-3-piezas",cta:"Ver leg&go →"},
        {eyebrow:"Pikler",title:"Adventure Set",text:"Juego de movimiento y escalada para crecer con autonomía y confianza.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/pikler-triangle-climber-with-swedish-wall-add-on-ages-6m7y-rainbow-0149ada6.jpg?v=1791133606",href:"/products/set-pikler-adventure-leg-go-rainbow-2-piezas",cta:"Ver Pikler →"}
      ]
    },
    "lenne": {
      name:"LENNE",
      sub:"ESTONIAN CHILDRENSWEAR",
      logo:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/lenne-logo.jpg?v=1791187610",
      lead:"Ropa de bebé y prendas de abrigo pensadas para un clima que no perdona.",
      paragraphs:[
        "Lenne trabaja desde Estonia con merino, algodones y soluciones térmicas orientadas a mantener calor sin renunciar a transpirabilidad y comodidad.",
        "En Casa a Cuestas nos hemos quedado con las referencias donde la marca realmente aporta valor: monos de merino, versiones con forro y sacos de invierno.",
        "Sus prendas están pensadas para ofrecer abrigo, comodidad y libertad de movimiento en climas fríos, con especial atención a tejidos y capas térmicas."
      ],
      badges:["🐑 Merino","❄️ Invierno","👶 Bebé","🇪🇪 Estonia"],
      cards:[
        {eyebrow:"Invierno",title:"Saco de invierno Lenne",text:"Una pieza práctica para frío real, con enfoque funcional y estética limpia.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/baby-winter-footmuff-bear-print-white-beige-one-size-25301a-1020-91d81ff0_d4bef08d-90a3-4bfe-8685-afd36bf70cde.jpg?v=1791114445",href:"/products/saco-de-invierno-para-bebe-lenne-talla-unica",cta:"Ver saco →"},
        {eyebrow:"Merino",title:"Mono de bebé",text:"Abrigo ligero, tacto suave y una prenda pensada para acompañar el día a día.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/merino-wool-baby-overall-beige-25501-507-eedd78fe_346c98c6-1583-469a-b3c5-1f72ef988818.jpg?v=1791114435",href:"/products/mono-de-merino-para-bebe-lenne",cta:"Ver mono →"}
      ]
    },
    "meowbaby": {
      name:"MeowBaby",
      sub:"PLAY · REST · GROW",
      lead:"Juego grande sin convertir el salón en un parque infantil improvisado.",
      paragraphs:[
        "MeowBaby diseña en Polonia sofás modulares, piscinas de bolas, pufs, columpios y módulos de espuma pensados para moverse, construir, descansar y volver a empezar.",
        "En Casa a Cuestas hemos agrupado colores y acabados para evitar fichas repetidas y facilitar la elección.",
        "Sus piezas buscan combinar juego, descanso y diseño para que puedan convivir con naturalidad en dormitorios, salones y zonas de juego."
      ],
      badges:["🧸 Juego","🛋️ Modular","🎨 Muchos colores","🧵 Tejidos certificados"],
      reviews:[
        {quote:"Los niños adoran el sofá. Lo usamos para leer, relajarse, ver la tele y construir fuertes. La calidad nos ha sorprendido mucho.",author:"Birgit"},
        {quote:"Es bonito, suave, se ve de calidad y los niños están encantados. Estamos muy satisfechos.",author:"Carla"}
      ],
      cards:[
        {eyebrow:"En uso",title:"Set de juego + piscina de bolas",text:"Módulos de espuma para trepar, construir y jugar con una piscina integrada.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/meowbaby-set-juego-lifestyle_8fa473b3-75d4-4928-8dd8-27b70efcca4d.png?v=1791143600",href:"/products/set-de-juego-meowbaby-con-piscina-de-bolas",cta:"Ver set →"},
        {eyebrow:"Relax infantil",title:"Puf Sako Teddy",text:"Textura, volumen y una pieza fácil de integrar en dormitorio o zona de juego.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/meowbaby-slimcord-teddy-sako-bag-beige-fec0ef94_cb60ab4a-1832-4c8b-b115-e0ab7dc217e7.jpg?v=1791113181",href:"/products/puf-sako-teddy-meowbaby-slimcord",cta:"Ver MeowBaby →"}
      ]
    },
    "montessori-house-bed": {
      name:"MONTESSORI HOUSE BED",
      sub:"AUTONOMY · PLAY · HOME",
      lead:"Muebles y estructuras pensados para que los niños hagan más cosas por sí mismos.",
      paragraphs:[
        "Montessori House Bed diseña en Letonia torres de aprendizaje, estructuras de escalada y muebles para integrar autonomía y juego en la vida cotidiana.",
        "Nos gusta porque sus piezas no son juguetes de dos tardes: están pensadas para formar parte de la casa y acompañar etapas.",
        "La propuesta combina autonomía, juego activo y mobiliario pensado para acompañar el crecimiento dentro de casa."
      ],
      badges:["🪵 Madera","🧗 Escalada","🍳 Torre de aprendizaje","⭐ Reviews"],
      reviews:[
        {quote:"Una de las mejores compras que he hecho para mis peques. Les encanta ayudar en la cocina y la usan constantemente.",author:"Cliente Montessori"},
        {quote:"La compré para mi hijo mayor y años después sigue usándola. Compré otra para el pequeño. Muy recomendable.",author:"Cliente Montessori"}
      ],
      cards:[
        {eyebrow:"Autonomía",title:"Torre de aprendizaje Montessori",text:"Para cocinar, lavarse las manos y participar en casa con más independencia.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/collections/kitchen-tower-for-kids-17_jpg.jpg?v=1791062676",href:"/products/2in1-kitchen-tower-table-chair",cta:"Ver torres →"},
        {eyebrow:"Movimiento",title:"Triángulo de escalada 2 en 1",text:"Juego activo, equilibrio y exploración con una estructura de madera integrada en casa.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/2-in-1-montessori-climbing-triangle-1070baa6.jpg?v=1791060781",href:"/products/2-in-1-montessori-climbing-triangle",cta:"Ver colección →"}
      ]
    },
    "north-beauty": {
      name:"NORTH BEAUTY",
      sub:"SAAREMAA · ESTONIA",
      logo:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/north-beauty-logo.webp?v=1791187614",
      lead:"Cosmética del norte con rutinas claras, estética limpia y enfoque de cuidado diario.",
      paragraphs:[
        "North Beauty nace en Saaremaa, Estonia, y trabaja cremas, aceites, sérums y tratamientos con una estética directa y muy visual.",
        "En Casa a Cuestas la enfocamos en sets temáticos para que cada ficha explique una rutina concreta, no una colección de botecitos sin contexto.",
        "Su identidad limpia y sus rutinas bien definidas hacen que resulte especialmente fácil entender qué aporta cada producto y cómo combinarlo."
      ],
      badges:["🌊 Saaremaa","🧴 Rutinas","🎁 Sets","🇪🇪 Hecho en Estonia"],
      cards:[
        {eyebrow:"Ritual destacado",title:"Reafirmante facial + corporal",text:"Una rutina de 4 piezas pensada para rostro y cuerpo con una presentación muy limpia.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/north-beauty-firming-set-normalized.png?v=1791125606",href:"/products/firming-body-and-face-kit-with-hyaluronic-acid-and-flower-extracts",cta:"Ver ritual →"}
      ]
    },
    "nurme": {
      name:"NURME",
      sub:"NATURAL COSMETICS · ESTONIA",
      logo:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/nurme-logo.png?v=1791191812",
      lead:"Cosmética natural artesanal para rutinas sencillas y fáciles de entender.",
      paragraphs:[
        "Nurme es una marca estonia centrada en fórmulas de cuidado diario e ingredientes naturales.",
        "En Casa a Cuestas la presentamos en rituales y sets para evitar dispersar la experiencia entre demasiadas referencias sueltas.",
        "La marca apuesta por fórmulas sencillas y rutinas fáciles de incorporar al día a día, con una estética natural y directa."
      ],
      badges:["🌿 Natural","👐 Artesanal","🇪🇪 Estonia","🎁 Sets"],
      cards:[
        {eyebrow:"Ritual facial",title:"Mini rutina Neroli · 4 piezas",text:"Una puerta de entrada compacta a la marca y una opción muy fácil de regalar.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/gift-set-sport-for-men-duplicate-c286b3dd.jpg?v=1791130233",href:"/products/mini-face-care-routine-gift-set-in-a-cosmetic-bag",cta:"Ver Nurme →"}
      ]
    },
    "purre": {
      name:"PURRÉ",
      sub:"DESIGN FOR PETS · MADE IN POLAND",
      lead:"Camas y sofás para perros pensados para convivir con una casa cuidada, no esconderse en una esquina.",
      paragraphs:[
        "Purré es una marca polaca centrada en camas y accesorios para perros y gatos con un enfoque claro en diseño contemporáneo, materiales agradables y funcionalidad diaria.",
        "La marca pertenece al mismo grupo que MeowBaby y fabrica en Polonia. Su propuesta combina tendencias de interiorismo con productos pensados para el descanso real de los animales.",
        "En Casa a Cuestas empezamos por sus sofás Lodie: versiones desenfundables y viscoelásticas que encajan especialmente bien en salones y dormitorios donde también importa la estética."
      ],
      badges:["🐕 Pets","🇵🇱 Hecho en Polonia","🛋️ Diseño interior","🧼 Desenfundable"],
      cards:[
        {eyebrow:"Descanso premium",title:"Sofá Lodie Memory",text:"Pana y espuma viscoelástica para un descanso más envolvente.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/purre-lodie-corduroy-memory-foam-dog-sofa-cloud-grey-s-f56da8c9_95c6a3a8-b59a-41e8-93f3-66e346bd46b3.jpg?v=1791113259",href:"/products/sofa-lodie-memory-para-perro-pana-viscoelastica",cta:"Ver sofá →"},
        {eyebrow:"Fácil de cuidar",title:"Sofá Lodie desenfundable",text:"Pana suave y funda extraíble para simplificar el mantenimiento diario.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/purre-lodie-corduroy-dog-sofa-with-removable-cover-cloud-grey-l-8b6d8007_b271f4fb-ad13-4b73-82d3-7c0df9a9ba40.jpg?v=1791113257",href:"/products/sofa-lodie-para-perro-pana-desenfundable",cta:"Ver sofá →"}
      ]
    },
    "ratt": {
      name:"RÄTT",
      sub:"HOME · TRAVEL · WATER · ESTONIA",
      lead:"Textiles ligeros y absorbentes para casa, viaje, piscina y playa.",
      paragraphs:[
        "RÄTT fabrica en Estonia prendas de baño y descanso con tejidos cómodos, absorbentes y fáciles de mantener.",
        "En Casa a Cuestas hemos reducido la selección a referencias con uso claro en España: albornoces unisex y un poncho surf pensado para actividades acuáticas.",
        "La prioridad aquí es la funcionalidad: prendas de secado rápido, cómodas de llevar y con margen suficiente para seguir siendo competitivas."
      ],
      badges:["🇪🇪 Hecho en Estonia","🏠 Hogar","🏖️ Playa & piscina","🧵 OEKO-TEX"],
      cards:[
        {eyebrow:"Playa & piscina",title:"Poncho surf de algodón waffle",text:"Ligero, absorbente y cómodo para cambiarse y secarse después del agua.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/DSC_4807-scaled.jpg?v=1791060941",href:"/products/short-sleeve-surf-poncho-cotton-waffle",cta:"Ver poncho surf →"},
        {eyebrow:"Hogar & viaje",title:"Albornoz unisex con capucha",text:"Algodón waffle ligero y transpirable para casa, viaje o después de la ducha.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/waffle-cotton-unisex-robe-with-hood-white-09e857e5.jpg?v=1791060976",href:"/products/waffle-cotton-unisex-robe-with-hood-light-grey",cta:"Ver albornoz →"}
      ]
    },
    "vegan-fox": {
      name:"VEGAN FOX",
      sub:"VEGAN · CRUELTY-FREE · LATVIA",
      lead:"Cosmética vegana familiar con rutinas sencillas y compromiso con el bienestar animal.",
      paragraphs:[
        "Vegan Fox es una marca familiar de Letonia que combina fórmulas de origen natural con una filosofía vegana y cruelty-free.",
        "En Casa a Cuestas la presentamos únicamente en rituales completos de 3 a 6 piezas para que cada propuesta tenga una función clara.",
        "Su filosofía combina cosmética vegana, fórmulas sencillas y un compromiso claro con el bienestar animal y el cuidado cotidiano."
      ],
      badges:["🌱 Vegana","🐰 Cruelty-free","⭐ Reviews","🇱🇻 Letonia"],
      cards:[
        {eyebrow:"3 pasos",title:"Ritual Antiacné",text:"Una rutina compacta para limpiar, tratar e hidratar con una secuencia fácil de seguir.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/acne-care-face-set-211e83e1.jpg?v=1791129636",href:"/products/acne-care-face-set",cta:"Ver ritual →"},
        {eyebrow:"Cuidado facial",title:"Ritual Anti-Edad",text:"Tres pasos de cuidado diario con enfoque vegano y presentación de regalo.",image:"https://cdn.shopify.com/s/files/1/1040/2529/3147/files/anti-age-face-care-set-fd55424c.jpg?v=1791129640",href:"/products/anti-age-face-care-set",cta:"Ver Anti-Edad →"}
      ]
    }
  };

  function resolveConfig(handle) {
    const raw = BRAND_CONFIG[handle];
    if (!raw) return null;
    return raw.alias ? BRAND_CONFIG[raw.alias] : raw;
  }

  function enhanceBrandPage() {
    const match = window.location.pathname.match(/^\/collections\/([^/]+)\/?$/);
    if (!match) return;
    const handle = match[1];
    const config = resolveConfig(handle);
    if (!config) return;

    const heading = document.querySelector('#MainContent h1');
    if (!heading) return;
    const wrapper = heading.closest('.section-content-wrapper');
    if (!wrapper || wrapper.dataset.cacBrandEnhanced === 'true') return;

    wrapper.dataset.cacBrandEnhanced = 'true';
    wrapper.classList.add('cac-brand-hero-grid');
    wrapper.replaceChildren();

    const left = document.createElement('div');
    left.className = 'cac-brand-copy';

    const logoHtml = config.logo
      ? '<img class="cac-brand-logo-image" src="' + config.logo + '" alt="Logo ' + config.name + '">'
      : '<div class="cac-brand-wordmark"><span class="cac-brand-wordmark__name">' + config.name + '</span>' +
        (config.sub ? '<span class="cac-brand-wordmark__sub">' + config.sub + '</span>' : '') + '</div>';

    left.innerHTML = '<div class="cac-brand-intro">' +
      logoHtml +
      '<p class="cac-brand-lead">' + config.lead + '</p>' +
      config.paragraphs.map(p => '<p>' + p + '</p>').join('') +
      '<div class="cac-brand-badges">' + config.badges.map(b => '<span>' + b + '</span>').join('') + '</div>' +
      '</div>';

    const aside = document.createElement('aside');
    aside.className = 'cac-brand-marketing';
    aside.setAttribute('aria-label', 'Destacados ' + config.name);

    aside.innerHTML = config.cards.map((card, index) =>
      '<a class="cac-brand-card ' + (index ? 'cac-brand-card--compact' : '') + '" href="' + card.href + '">' +
        '<img class="cac-brand-card__image" src="' + card.image + '" alt="' + card.title + '">' +
        '<span class="cac-brand-card__veil"></span>' +
        '<span class="cac-brand-card__content">' +
          '<span class="cac-brand-card__eyebrow">' + card.eyebrow + '</span>' +
          '<h3>' + card.title + '</h3>' +
          '<p>' + card.text + '</p>' +
          '<span class="cac-brand-card__cta">' + card.cta + '</span>' +
        '</span>' +
      '</a>'
    ).join('') +
    (config.reviews ? '<div class="cac-brand-reviews"><div class="cac-brand-reviews__title">Lo que cuentan quienes ya lo usan</div>' +
      config.reviews.map(r => '<blockquote><p>“' + r.quote + '”</p><footer>— ' + r.author + '</footer></blockquote>').join('') +
      '</div>' : '');

    wrapper.appendChild(left);
    wrapper.appendChild(aside);

    if (config.featuredProducts && config.featuredProducts.length) {
      const featured = document.createElement('section');
      featured.className = 'cac-brand-featured-products';
      featured.innerHTML =
        '<div class="cac-brand-featured-products__head"><h2>Rituales ' + config.name + '</h2><span>Selección disponible en Casa a Cuestas</span></div>' +
        '<div class="cac-brand-featured-products__grid">' +
        config.featuredProducts.map(p =>
          '<a class="cac-brand-product-tile" href="' + p.href + '">' +
            '<img src="' + p.image + '" alt="' + p.title + '">' +
            '<div><strong>' + p.title + '</strong><span>' + p.price + '</span></div>' +
          '</a>'
        ).join('') +
        '</div>';
      const sectionWrapper = wrapper.closest('.shopify-section');
      if (sectionWrapper && sectionWrapper.parentElement) {
        sectionWrapper.insertAdjacentElement('afterend', featured);
      } else {
        wrapper.insertAdjacentElement('afterend', featured);
      }
    }

    // Fallback fuerte: algunos overlays del tema/preview pueden bloquear la navegación
    // de los <a>. Forzamos el destino al clicar cualquier tarjeta de marca.
    aside.querySelectorAll('.cac-brand-card').forEach((card) => {
      card.dataset.cacBrandForcedNavigation = 'true';
      card.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const href = card.getAttribute('href');
        if (href) window.location.assign(href);
      }, true);
    });
  }

  const PRODUCT_VENDOR_MAP = {
    "Magrada Organic Cosmetics": { label:"Magrada Organic Cosmetics", handle:"magrada-organic-cosmetics" },
    "Candledust": { label:"Candledust", handle:"candledust" },
    "Ewart Woods": { label:"Ewart Woods", handle:"ewart-woods" },
    "HOIA homespa": { label:"HOIA homespa", handle:"hoia-homespa" },
    "HOIA": { label:"HOIA homespa", handle:"hoia-homespa" },
    "leg&go": { label:"leg&go", handle:"leg-go" },
    "Lenne": { label:"Lenne", handle:"lenne" },
    "Lizush": { label:"Lizush", handle:"lizush" },
    "MeowBaby": { label:"MeowBaby", handle:"meowbaby" },
    "Montessori House Bed": { label:"Montessori House Bed", handle:"montessori-house-bed" },
    "North Beauty": { label:"North Beauty", handle:"north-beauty" },
    "Nurme": { label:"Nurme", handle:"nurme" },
    "Purré": { label:"Purré", handle:"purre" },
    "RÄTT": { label:"RÄTT", handle:"ratt" },
    "Vegan Fox": { label:"Vegan Fox", handle:"vegan-fox" }
  };

  async function enhanceProductBrandLink() {
    if (!window.location.pathname.startsWith('/products/')) return;
    try {
      const response = await fetch(window.location.pathname + '.js', { credentials:'same-origin' });
      if (!response.ok) return;
      const product = await response.json();
      const brand = PRODUCT_VENDOR_MAP[product.vendor];
      if (!brand) return;

      const h1 = document.querySelector('#MainContent h1');
      if (!h1) return;
      const details = h1.closest('.product-details, [class*="product-details"], .group-block, .layout-panel-flex') || h1.parentElement;
      if (!details || details.querySelector('.cac-product-brand-link')) return;

      const box = document.createElement('div');
      box.className = 'cac-product-brand-link';
      box.innerHTML =
        '<div class="cac-product-brand-link__copy">' +
          '<span class="cac-product-brand-link__eyebrow">Marca</span>' +
          '<strong>' + brand.label + '</strong>' +
          '<span>Conoce su historia, filosofía y selección en Casa a Cuestas.</span>' +
        '</div>' +
        '<a href="/collections/' + brand.handle + '">Conoce la marca →</a>';

      const titleGroup = h1.closest('.group-block, [class*="group"]');
      if (titleGroup) {
        titleGroup.appendChild(box);
      } else if (h1.parentElement) {
        h1.parentElement.appendChild(box);
      }
    } catch (e) {}
  }

  function runCACEnhancements() {
    enhanceBrandPage();
    enhanceProductBrandLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCACEnhancements, { once: true });
  } else {
    runCACEnhancements();
  }
})();